/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

/**
 * RoleGuard — Layout route guard for role-based access control.
 * Used as a React Router v6 layout route: <Route element={<RoleGuard role="SUPER_ADMIN" />}>
 * Renders <Outlet /> if user has the required role, otherwise redirects to /access-violation.
 */

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

interface RoleGuardProps {
  role: string;
}

export function RoleGuard({ role }: RoleGuardProps) {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (user?.role !== role) {
    return (
      <Navigate
        to="/access-violation"
        state={{ from: location.pathname, violationType: 'ROLE_VIOLATION', requiredRole: role }}
        replace
      />
    );
  }

  return <Outlet />;
}
